import {
    AlertDialog,
    AlertDialogBody,
    AlertDialogContent,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogOverlay,
    Button,
    HStack,
    Input,
    InputGroup,
    InputLeftAddon,
    Spinner,
    Table,
    TableContainer,
    Tbody,
    Text,
    useDisclosure,
    UseDisclosureReturn,
    useToast,
    VStack
} from "@chakra-ui/react";
import React, {ChangeEvent, useEffect, useRef, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {editEventSchemaNew, eventSchemaNew} from "../../../../data/schema/eventSchema";
import {Resolver, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {EventModelNew, EventQueryParamsNew} from "../../../../data/model/Event";
import {addEventNew, addMediaNew, deleteMediaNew, editEventNew, getEventNew} from "../../../../data/api/Customer";
import {ArrowBackIcon, CheckCircleIcon} from "@chakra-ui/icons";
import {scrollbarCss} from "../../../../theme/theme";
import {getData, toolbarOptions} from "../../../../utils/Utils";
import ReactQuill from "react-quill";
import {toBase64} from "../../../signup/pages/SignupPageThree";
import {AddTableRow} from "../../../../components/atoms/AddTableRow/AddTableRow";
import {SetImageModel} from "../../../../data/model/Producer";
import {useMutation, useQuery} from "@tanstack/react-query";
import {BaseResponse} from "../../../../data/model/BaseResponse";
import {getDefaultDate, getDefaultTime} from "../Lots/AddProductLotPage";
import {ImageSelectorComponent} from "../../../../components/molecules/ImageSelectorComponent/ImageSelectorComponent";
import {MediaSelectorComponent} from "../../../../components/molecules/MediaSelectorComponent/MediaSelectorComponent";
import AddressInput from "../../../../components/molecules/MapChoosPoint";

export function DeleteImageDialog({isOpen, cancelRef, onClose, id, onExecute}: {
    isOpen: boolean,
    cancelRef: React.RefObject<HTMLButtonElement>,
    onClose: () => void,
    onExecute: () => void,
    id?: string;
}) {
    const {mutateAsync, isPending} = useMutation({
        mutationKey: ["delete-media", id],
        mutationFn: (id: string) => deleteMediaNew(id || "")
    })

    return <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
    >
        <AlertDialogOverlay>
            <AlertDialogContent>
                <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                    Elimina media
                </AlertDialogHeader>

                <AlertDialogBody>
                    Sei sicuro di voler continuare? L'operazione è irreversibile.
                </AlertDialogBody>

                <AlertDialogFooter>
                    <Button ref={cancelRef} onClick={onClose}>
                        Annulla
                    </Button>
                    <Button isLoading={isPending} colorScheme='red' onClick={async () => {
                        await mutateAsync(id || "").then(() => {
                            onExecute();
                            onClose();
                        });
                    }} ml={3}>
                        Prosegui
                    </Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialogOverlay>
    </AlertDialog>;
}

export const AddEventPage = () => {
    const navigate = useNavigate();
    const toast = useToast();

    const {id} = useParams();

    const responseData = useQuery({
        queryKey: ['get-event', id],
        enabled: !!id,
        queryFn: () => getEventNew(id || ""),
        refetchOnWindowFocus: "always",
        staleTime: 0
    });

    const {isOpen, onOpen, onClose}: UseDisclosureReturn = useDisclosure();
    const cancelRef = useRef<HTMLButtonElement>(null);

    const [addressInput, setAddressInput] = useState<string>('');
    const [lat, setLat] = useState<string>('');
    const [lng, setLng] = useState<string>('');

    const {data: dataOld, refetch} = responseData || {};

    const eventResponse = dataOld?.data as BaseResponse<EventModelNew | undefined>;
    const event = eventResponse?.data;

    const methods = useForm<EventQueryParamsNew>({
        mode: "all",
        resolver: yupResolver(id ? editEventSchemaNew : eventSchemaNew) as Resolver<EventQueryParamsNew>
    })

    const [imageToDelete, setImageToDelete] = useState<string[]>([]);

    const {
        register,
        handleSubmit,
        setValue,
        formState: {
            errors,
            isSubmitting
        }
    } = methods;

    const [descriptionQuill, setDescriptionQuill] = useState('');

    useEffect(() => {
        setValue("description", descriptionQuill);
    }, [descriptionQuill]);

    const onSubmit = async (event: EventQueryParamsNew) => {
        const list: SetImageModel[] = [];

        setValue("lat", Number(lat));
        setValue("long", Number(lng));

        mainImage?.file && list?.push(mainImage);
        images?.forEach(value => list?.push(value));

        // mainImage?.imageBase64 && list?.push(mainImage.imageBase64);
        // images?.forEach(value => list?.push(value.imageBase64 || ""));

        const eventToSend: EventQueryParamsNew = {
            ...event,
            // mediaList: list,
            startDate: (!startDate && !startTime) ? undefined : new Date(startDate?.getFullYear() || 0, startDate?.getMonth() || 0, startDate?.getDate() || 0, startTime?.getHours() || 0, startTime?.getMinutes() || 0, startTime?.getSeconds() || 0).getTime(),
            endDate: (!endDate && !endTime) ? undefined : new Date(endDate?.getFullYear() || 0, endDate?.getMonth() || 0, endDate?.getDate() || 0, endTime?.getHours() || 0, endTime?.getMinutes() || 0, endTime?.getSeconds() || 0).getTime(),
        }

        if (id) {
            console.log(startDate?.toString());
            await editEventNew(id, eventToSend).then(async (data) => {
                const eventNew = getData<EventModelNew>(data);
                console.log(imageToDelete);

                for (const value of imageToDelete) {
                    if (value !== "") await deleteMediaNew(value);
                }

                for (const value of list) {
                    value.file && await addMediaNew({
                        type: "Event",
                        id: id || "",
                        isMain: value.isMain || false,
                    }, value.file);
                }

                refetch().then(() => navigate("/events"));
            }).catch(reason => {
                toast({
                    title: "Si è verificato un errore",
                    description: reason?.message ?? "-"
                });
            });
        } else {
            await addEventNew(eventToSend).then(async (data) => {
                const eventNew = getData<EventModelNew>(data);

                for (const value of list) {
                    value.file && await addMediaNew({
                        type: "Event",
                        id: eventNew?.id || "",
                        isMain: value.isMain || false,
                    }, value.file);
                }

                navigate("/events", {replace: true});
            }).catch(reason => {
                toast({
                    title: "Si è verificato un errore",
                    description: reason?.message ?? "-"
                });
            });
        }
    }

    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [startTime, setStartTime] = useState<Date | null>(null);
    const [endTime, setEndTime] = useState<Date | null>(null);

    const [images, setImages] = useState<SetImageModel[]>([])
    const [mainImage, setMainImage] = useState<SetImageModel | undefined>()

    const imageInputRef: React.RefObject<HTMLInputElement> = useRef(null);
    const logoInputRef: React.RefObject<HTMLInputElement> = useRef(null);

    const handleButtonClick = () => {
        logoInputRef?.current?.click();
    }

    const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];

            toBase64(file).then(base64String => {
                const base64 = base64String as string;

                setImages([...(images || []), {
                    imageBase64: base64,
                    imageUrl: URL.createObjectURL(file),
                }]);
            });
        }
    };

    const handleLogoChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];

            toBase64(file).then(base64String => {
                const base64 = base64String as string;

                setMainImage({
                    imageBase64: `true&${base64}`,
                    imageUrl: URL.createObjectURL(file),
                });
            });
        }
    };

    const handleImageButtonClick = () => {
        imageInputRef?.current?.click();
    }

    useEffect(() => {
        if (event) {
            event.description && setDescriptionQuill(event.description);
            const mainImage = event.mediaList?.find(value => value.isMain);
            const otherImages = event.mediaList?.filter(value => !value.isMain);

            mainImage && setMainImage({
                id: mainImage.id,
                imageUrl: mainImage.url
            });

            if ((otherImages?.length || 0) > 0) {
                const otherImagesList: SetImageModel[] = otherImages?.map(value => ({
                    imageUrl: value.url,
                    id: value.id
                })) || [];

                setImages(otherImagesList);
            }

            if (event.startDate) {
                const startDate = new Date(event?.startDate);
                setStartDate(startDate);
                setStartTime(startDate);
            }

            if (event.endDate) {
                const endDate = new Date(event?.endDate);
                setEndDate(endDate);
                setEndTime(endDate);
            }
        }
    }, [event]);

    function getMainImageRow() {
        return <AddTableRow name={"Immagine"}>
            <ImageSelectorComponent
                setImageModel={setMainImage}
                imageModel={mainImage}
                isMain={true}
                handleCloseButtonClick={(model) => {
                    if (id) setImageToDelete([...(imageToDelete || []), model?.id || ""]);
                    setMainImage(undefined);
                }}
                description={"Seleziona l'immagine principale del prodotto, verrà mostrata nell'anteprima."}/>
        </AddTableRow>;
    }

    function getImagesRow() {
        return <AddTableRow name={"Media"}>
            <MediaSelectorComponent
                setImages={setImages}
                images={images}
                handleCloseButtonClick={(model) => {
                    if (id) setImageToDelete([...(imageToDelete || []), model?.id || ""]);
                }}
                description={"Seleziona le foto, i video o gli audio che vorresti utilizzare per descrivere al meglio il tuo prodotto."}
            />
        </AddTableRow>;
    }

    function getTitleRow() {
        return <AddTableRow name={"Titolo"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <Input
                    id={"title"}
                    inputMode={"text"}
                    colorScheme={"primary"}
                    variant='filled'
                    defaultValue={event?.title}
                    _placeholder={{
                        fontSize: 14
                    }}
                    errorBorderColor={"error.700"}
                    disabled={isSubmitting}
                    isInvalid={!!errors.title}
                    focusBorderColor={!!errors.title ? "error.700" : "primary.400"}
                    {...register('title')}
                    placeholder='Es. Il mio evento'/>
                {!!errors.title && <Text fontSize={14}
                                         alignSelf={"start"}
                                         textColor={"error.700"}>
                    {errors.title && errors.title.message}
                </Text>}
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Il titolo che vuoi dare al tuo
                    evento</Text>
            </VStack>
        </AddTableRow>;
    }

    function getDescriptionRow() {
        return <AddTableRow name={"Descrizione"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <ReactQuill theme="snow" modules={{toolbar: toolbarOptions}}
                            value={descriptionQuill}
                            onChange={setDescriptionQuill}/>
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Scrivi una descrizione completa.
                    Verrà
                    mostrata nella pagina di dettaglio del prodotto.</Text>
            </VStack>
        </AddTableRow>;
    }

    function getDataRow() {
        console.log(event?.startDate?.toString());
        return <AddTableRow name={"Data"}>
            <HStack>
                <VStack flex={1} alignItems={"flex-start"}>
                    <Text fontWeight={"bold"}>Inizio</Text>
                    <Input
                        id={"date_start_day"}
                        type={"date"}
                        defaultValue={getDefaultDate(((event?.startDate || 0) / 1000)?.toString())}
                        // defaultValue={event?.startDate}
                        colorScheme={"primary"}
                        focusBorderColor={"primary.400"}
                        onChange={event => setStartDate(event.target.valueAsDate)}
                    />
                </VStack>
                <VStack flex={1} alignItems={"flex-start"}>
                    <Text fontWeight={"bold"}>Fine</Text>
                    <Input
                        id={"date_end_day"}
                        type={"date"}
                        defaultValue={getDefaultDate(((event?.endDate || 0) / 1000)?.toString())}
                        colorScheme={"primary"}
                        focusBorderColor={"primary.400"}
                        onChange={event => setEndDate(event.target.valueAsDate)}/>
                </VStack>
            </HStack>
        </AddTableRow>;
    }

    function getHourRow() {
        return <AddTableRow name={"Orario"}>
            <HStack>
                <VStack flex={1} alignItems={"flex-start"}>
                    <Text fontWeight={"bold"}>Inizio</Text>
                    <Input
                        id={"date_start_time"}
                        defaultValue={getDefaultTime(((event?.startDate || 0) / 1000)?.toString())}
                        type={"time"} colorScheme={"primary"}
                        focusBorderColor={"primary.400"}
                        onChange={event => setStartTime(event.target.valueAsDate)}
                    />
                </VStack>
                <VStack flex={1} alignItems={"flex-start"}>
                    <Text fontWeight={"bold"}>Fine</Text>
                    <Input
                        id={"date_end_time"}
                        defaultValue={getDefaultTime(((event?.endDate || 0) / 1000)?.toString())}
                        type={"time"} colorScheme={"primary"}
                        focusBorderColor={"primary.400"}
                        onChange={event => setEndTime(event.target.valueAsDate)}
                    />
                </VStack>
            </HStack>
        </AddTableRow>;
    }

    function getPlaceRow() {
        return <AddTableRow name={"Luogo"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <Input
                    id={"place"}
                    inputMode={"text"}
                    colorScheme={"primary"}
                    variant='filled'
                    defaultValue={event?.location}
                    _placeholder={{
                        fontSize: 14
                    }}
                    errorBorderColor={"error.700"}
                    disabled={isSubmitting}
                    isInvalid={!!errors.location}
                    focusBorderColor={!!errors.location ? "error.700" : "primary.400"}
                    {...register('location')}
                    placeholder='Es. Villa Bellini, Catania'/>
                {!!errors.location && <Text fontSize={14}
                                            alignSelf={"start"}
                                            textColor={"error.700"}>
                    {errors.location && errors.location.message}
                </Text>}
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Dove avrà luogo l'evento.</Text>
            </VStack>
        </AddTableRow>;
    }

    function getPriceRow() {
        return <AddTableRow name={"Prezzo"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <InputGroup>
                    <InputLeftAddon>€</InputLeftAddon>
                    <Input
                        id={"price"}
                        inputMode={"numeric"}
                        colorScheme={"primary"}
                        variant='filled'
                        defaultValue={event?.price}
                        _placeholder={{
                            fontSize: 14
                        }}
                        errorBorderColor={"error.700"}
                        disabled={isSubmitting}
                        type={"number"}
                        isInvalid={!!errors.price}
                        focusBorderColor={!!errors.price ? "error.700" : "primary.400"}
                        {...register('price')}
                        placeholder='Es. 10.0'/>
                </InputGroup>
                {!!errors.price && <Text fontSize={14}
                                         alignSelf={"start"}
                                         textColor={"error.700"}>
                    {errors.price && errors.price.message}
                </Text>}
            </VStack>
        </AddTableRow>;
    }

    function getPositionRow() {
        return <AddTableRow name={"Coordinate posizione"}><AddressInput
            address={addressInput}
            setAddress={setAddressInput}
            lat={lat}
            setLat={setLat}
            lng={lng}
            setLng={setLng}
        /></AddTableRow>
    }

    function getPositionRowOld() {
        return <AddTableRow name={"Coordinate posizione"}>
            <HStack w={"100%"}>
                <VStack alignItems={"flex-start"} flex={1}>
                    <Text fontWeight={"bold"}>Latitudine</Text>
                    <Input
                        id={"position_lat"}
                        inputMode={"text"}
                        colorScheme={"primary"}
                        variant='filled'
                        _placeholder={{
                            fontSize: 14
                        }}
                        defaultValue={event?.lat}
                        errorBorderColor={"error.700"}
                        disabled={isSubmitting}
                        isInvalid={!!errors.lat}
                        focusBorderColor={!!errors.lat ? "error.700" : "primary.400"}
                        {...register('lat')}
                        placeholder='Es. 0.39482109'/>
                    {!!errors.lat && <Text fontSize={14}
                                           alignSelf={"start"}
                                           textColor={"error.700"}>
                        {errors.lat && errors.lat.message}
                    </Text>}
                </VStack>
                <VStack alignItems={"flex-start"} flex={1}>
                    <Text fontWeight={"bold"}>Longitudine</Text>
                    <Input
                        id={"position_lng"}
                        inputMode={"text"}
                        colorScheme={"primary"}
                        variant='filled'
                        _placeholder={{
                            fontSize: 14
                        }}
                        defaultValue={event?.long}
                        errorBorderColor={"error.700"}
                        disabled={isSubmitting}
                        isInvalid={!!errors.long}
                        focusBorderColor={!!errors.long ? "error.700" : "primary.400"}
                        {...register('long')}
                        placeholder='Es. 0.39482109'/>
                    {!!errors.long && <Text fontSize={14}
                                            alignSelf={"start"}
                                            textColor={"error.700"}>
                        {errors.long && errors.long.message}
                    </Text>}
                </VStack>
            </HStack>
        </AddTableRow>;
    }

    function getContactMailRow() {
        return <AddTableRow name={"Email di contatto"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <Input
                    id={"contacts_email"}
                    inputMode={"text"}
                    colorScheme={"primary"}
                    variant='filled'
                    _placeholder={{fontSize: 14}}
                    errorBorderColor={"error.700"}
                    disabled={isSubmitting}
                    defaultValue={event?.contactEmail}
                    isInvalid={!!errors.contactEmail}
                    focusBorderColor={!!errors.contactEmail ? "error.700" : "primary.400"}
                    {...register('contactEmail')}
                    placeholder='Es. info@ilmioevento.it'/>
                {!!errors.contactEmail && <Text fontSize={14}
                                                alignSelf={"start"}
                                                textColor={"error.700"}>
                    {errors.contactEmail && errors.contactEmail.message}
                </Text>}
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Inserisci la mail per chiedere
                    informazioni sul tuo evento.</Text>
            </VStack>
        </AddTableRow>;
    }

    function getContactPhoneRow() {
        return <AddTableRow name={"Telefono di contatto"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <Input
                    id={"contacts_phone"}
                    inputMode={"text"}
                    colorScheme={"primary"}
                    variant='filled'
                    _placeholder={{fontSize: 14}}
                    errorBorderColor={"error.700"}
                    defaultValue={event?.contactPhone}
                    disabled={isSubmitting}
                    isInvalid={!!errors.contactPhone}
                    focusBorderColor={!!errors.contactPhone ? "error.700" : "primary.400"}
                    {...register('contactPhone')}
                    placeholder='Es. 0951234567'/>
                {!!errors.contactPhone && <Text fontSize={14}
                                                alignSelf={"start"}
                                                textColor={"error.700"}>
                    {errors.contactPhone && errors.contactPhone.message}
                </Text>}
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Inserisci un numero di telefono
                    per
                    chiedere informazioni sul tuo evento.</Text>
            </VStack>
        </AddTableRow>;
    }

    function getWebSiteRow() {
        return <AddTableRow name={"Sito web"}>
            <VStack alignItems={"flex-start"} w={"100%"}>
                <Input
                    id={"contacts_website"}
                    inputMode={"text"}
                    colorScheme={"primary"}
                    variant='filled'
                    _placeholder={{
                        fontSize: 14
                    }}
                    errorBorderColor={"error.700"}
                    defaultValue={event?.contactWeb}
                    disabled={isSubmitting}
                    isInvalid={!!errors.contactWeb}
                    focusBorderColor={!!errors.contactWeb ? "error.700" : "primary.400"}
                    {...register('contactWeb')}
                    placeholder='Es. https://www.ilmioevento.it'/>
                {!!errors.contactWeb && <Text fontSize={14}
                                              alignSelf={"start"}
                                              textColor={"error.700"}>
                    {errors.contactWeb && errors.contactWeb.message}
                </Text>}
                <Text fontSize={"14px"} color={"rgba(0,0,0,0.6)"}>Sito web dell'evento</Text>
            </VStack>
        </AddTableRow>;
    }

    return <VStack id={"container"} w={"100%"} h={"100%"} alignItems={"center"}>
        <HStack cursor={"pointer"} h={"64px"} px={"24px"} borderRadius={"24px"} position={"absolute"}
                alignItems={"center"} zIndex={5}
                justifyContent={"center"} bottom={"24px"} right={"48px"}
                backgroundColor={isSubmitting ? "primary.100" : "secondary.200"}
                _hover={{backgroundColor: "tertiary.200"}} onClick={handleSubmit(onSubmit)}>
            {isSubmitting ? <Spinner width={"24px"} height={"24px"}/> :
                <CheckCircleIcon w={"24px"} h={"24px"} color={"primary.400"} alignSelf={"center"}/>}
            <Text fontWeight={"bold"} color={"primary.400"}>Conferma</Text>
        </HStack>

        <VStack justifyContent={"center"} flex={1} alignItems={"center"} overflowY={"hidden"}>
            <HStack w={"100%"} alignItems={"center"} pt={"16px"} justifyContent={"space-between"}>
                <HStack alignItems={"center"} p={"16px"} _hover={{
                    backgroundColor: "tertiary.200",
                    borderRadius: "16px",
                }} cursor={"pointer"} onClick={() => {
                    navigate("/events", {replace: true});
                }}>
                    <ArrowBackIcon/>
                    <Text fontWeight={"bold"}>Indietro</Text>
                </HStack>
            </HStack>
            <Text fontSize={"24px"} justifySelf={"center"} fontWeight={"bold"} ms={"24px"}>Nuovo evento</Text>
            <TableContainer w={"100%"} alignItems={"center"} whiteSpace={"pre-line"} mr={"16px"} overflowY={"scroll"}
                            css={scrollbarCss({marginRight: 48})}>
                <Table variant={"none"} w={"70%"} mx={"auto"}>
                    <Tbody>
                        {getTitleRow()}
                        {getDescriptionRow()}
                        {getDataRow()}
                        {getHourRow()}
                        {getPlaceRow()}
                        {getPriceRow()}
                        {getPositionRow()}
                        {getContactMailRow()}
                        {getContactPhoneRow()}
                        {getWebSiteRow()}
                        {getMainImageRow()}
                        {getImagesRow()}
                    </Tbody>
                </Table>
            </TableContainer>
        </VStack>

        {/*<DeleteImageDialog isOpen={isOpen} cancelRef={cancelRef} onClose={onClose}/>*/}
    </VStack>
}
